import React, { Suspense } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Card, Tabs, Spin } from '@arco-design/web-react';
import { useTranslation } from 'react-i18next';
import ErrorBoundary from '@/modules/core/error-handling/ErrorBoundary';

const DailyReport = React.lazy(() => import('./reports/DailyReport'));
const MonthlyReport = React.lazy(() => import('./reports/MonthlyReport'));
const CustomReport = React.lazy(() => import('./reports/CustomReport'));

const TabPane = Tabs.TabPane;

const TabFallback = () => (
  <div style={{ padding: 40, textAlign: 'center' }}>
    <Spin size={30} />
  </div>
);

const ReportesPage = () => {
  const { t } = useTranslation('finance');
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = searchParams.get('tab') || 'diario';

  const handleTabChange = (tab) => {
    setSearchParams({ tab }, { replace: true });
  };

  return (
    <div style={{ padding: 0 }}>
      <Tabs
        activeTab={activeTab}
        onChange={handleTabChange}
        lazyload
        destroyOnHide={false}
        style={{ marginTop: 8 }}
      >
        <TabPane key="diario" title={t('tabs.daily')}>
          <ErrorBoundary>
            <Suspense fallback={<TabFallback />}>
              <Card style={{ marginTop: 8 }}>
                <DailyReport />
              </Card>
            </Suspense>
          </ErrorBoundary>
        </TabPane>

        <TabPane key="mensual" title={t('tabs.monthly')}>
          <ErrorBoundary>
            <Suspense fallback={<TabFallback />}>
              <Card style={{ marginTop: 8 }}>
                <MonthlyReport />
              </Card>
            </Suspense>
          </ErrorBoundary>
        </TabPane>

        <TabPane key="personalizado" title={t('tabs.custom')}>
          <ErrorBoundary>
            <Suspense fallback={<TabFallback />}>
              <Card style={{ marginTop: 8 }}>
                <CustomReport />
              </Card>
            </Suspense>
          </ErrorBoundary>
        </TabPane>
      </Tabs>
    </div>
  );
};

export default ReportesPage;
